import { useAsyncActionHandler, useSelectedNetwork } from "@umami/state";

import { saplingWorkerService } from "@/services/saplingWorkerService";

type UsePrepareSaplingProps = {
  toAddress: string;
  amount: number;
  memo?: string;
};

export const usePrepareSapling = ({
  toAddress,
  amount,
  memo: memo = "",
}: UsePrepareSaplingProps) => {
  const { isLoading, handleAsyncAction } = useAsyncActionHandler();
  const { saplingContractAddress: contractAddress = "", rpcUrl } = useSelectedNetwork();

  const prepareSapling = (mnemonic: string) =>
    handleAsyncAction(async () => {
      const shieldedTx = await saplingWorkerService.prepareSaplingTransaction({
        mnemonic,
        contractAddress,
        rpcUrl,
        transactions: [
          {
            to: toAddress,
            amount,
            memo,
            mutez: false,
          },
        ],
      });

      return shieldedTx;
    });

  return {
    prepareSapling,
    isLoading,
  };
};
